/* eslint-disable complexity */
import React, { useEffect, useState } from "react";
import { IndicatorContent } from "./../../Common/index";
import "./index.less";
import { getScheduleParticipantList, ResStatus } from "@/api/calendar";
import { useTranslation } from "react-i18next";
import IconFont from "@/components/icon";
import style from "./index.module.less";
import { message } from "antd";
import UserStatusListPopover from "@/baseComponents/UserStatusListPopover";

export interface IProps {
  acceptCount: Number;
  unreadCount: Number;
  rejectCount: Number;
  content: any;
  userData: any;
  disableUserCard?: boolean;
}
const maxLenght = 7;
function ParticipantIndicator(props: IProps) {
  const { t } = useTranslation("calendar");
  const { acceptCount, unreadCount, rejectCount, content, userData } = props;
  const [listObj, setListObj] = useState<any>([]);
  const [isClicked, setIsClicked] = useState(false);

  useEffect(() => {
    async function fetchData() {
      // 查询全部参与人
      const { scheduleId } = content;
      const [res, err]: any = await getScheduleParticipantList({
        pageNum: 0,
        pageSize: 0,
        scheduleId: scheduleId,
        pageQuery: false
      });
      console.log("查询全部参与人-->>", res, err);
      if (err) {
        message.error("查询日程参与人失败");
      }
      let participantObjs: { title: string; list: any[]; clstag: string }[] = [
        {
          title: t("some-unread"),
          list: [],
          clstag: "pageclick|keycount|xtbg_calhome_1640073907694|7"
        },
        {
          title: t("some-accept"),
          list: [],
          clstag: "pageclick|keycount|xtbg_calhome_1640073907694|6"
        },
        {
          title: t("some-reject"),
          list: [],
          clstag: "pageclick|keycount|xtbg_calhome_1640073907694|8"
        }
      ];
      res?.participant?.forEach((item: any) => {
        let participantObj = null;
        switch (item.resStatus) {
          case ResStatus.Unread:
            participantObj = participantObjs[0];
            break;
          case ResStatus.Agree:
            participantObj = participantObjs[1];
            break;
          case ResStatus.Reject:
            participantObj = participantObjs[2];
            break;
          default:
            participantObj = participantObjs[0];
            break;
        }
        item.user.rejectReason = item.message;
        item.user.resStatus = item.resStatus;
        participantObj.list.push(item.user);
      });
      setListObj(participantObjs);
    }
    if (isClicked) {
      fetchData();
    }
  }, [isClicked, content, t]);

  let participantRenderList = [...content.participant];
  let isShowMoreBtn = false;

  if (participantRenderList.length > maxLenght) {
    participantRenderList.splice(maxLenght);
    isShowMoreBtn = true;
  }

  return (
    <IndicatorContent
      indicator={() => (
        <div className="calendar-tooltip-content-label" style={{ marginTop: "0px" }}>{`${t(
          "participant"
        )}`}</div>
      )}
    >
      <p
        className="info info-important info-important-participant"
        clstag="pageclick|keycount|xtbg_calhome_1640073907694|5"
        onClick={() => {
          if (isClicked) return;
          setIsClicked(true);
        }}
      >
        <UserStatusListPopover
          popoverName="getTabs"
          listObj={listObj}
          disable={true}
          disableUserCard
          userData={userData}
          userPopover="schedule"
          userPopoverText="participant"
        >
          <div className="participant-content">
            <span className="exact-info">
              {t("total")}
              {Number(acceptCount) + Number(unreadCount) + Number(rejectCount)}
              {t("people")}（{t("some-unread")}
              {unreadCount}
              {t("people")}，{t("some-accept")}
              {acceptCount}
              {t("people")}，{t("some-reject")}
              {rejectCount}
              {t("people")}）
              {/* {acceptCount}
                      {t('some-accept')}，{unreadCount}
                      {t('some-unread')}，{rejectCount}
                      {t('some-reject')} */}
            </span>
            <IconFont
              type="iconlog_enter"
              className={`${style["icon-more"]} icon-toggle`}
              style={{ color: "#DEE0E3" }}
            />
          </div>
        </UserStatusListPopover>
      </p>
    </IndicatorContent>
  );
}

export default ParticipantIndicator;
